// source: core/protos/representation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
goog.exportSymbol('proto.vertexvis.protobuf.core.RepresentationId', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.RepresentationId.IdCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.RepresentationPredefinedId', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.RepresentationId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.RepresentationId.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.RepresentationId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.RepresentationId.displayName = 'proto.vertexvis.protobuf.core.RepresentationId';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.RepresentationId.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.RepresentationId.IdCase = {
  ID_NOT_SET: 0,
  SYSTEM_ID: 1,
  SUPPLIED_ID: 2,
  PREDEFINED_ID: 3
};

/**
 * @return {proto.vertexvis.protobuf.core.RepresentationId.IdCase}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.getIdCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.RepresentationId.IdCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.RepresentationId.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.RepresentationId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.RepresentationId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.RepresentationId.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemId: (f = msg.getSystemId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    suppliedId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    predefinedId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.RepresentationId}
 */
proto.vertexvis.protobuf.core.RepresentationId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.RepresentationId;
  return proto.vertexvis.protobuf.core.RepresentationId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.RepresentationId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.RepresentationId}
 */
proto.vertexvis.protobuf.core.RepresentationId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setSystemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuppliedId(value);
      break;
    case 3:
      var value = /** @type {!proto.vertexvis.protobuf.core.RepresentationPredefinedId} */ (reader.readEnum());
      msg.setPredefinedId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.RepresentationId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.RepresentationId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.RepresentationId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {!proto.vertexvis.protobuf.core.RepresentationPredefinedId} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional Uuid2l system_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.getSystemId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.RepresentationId} returns this
*/
proto.vertexvis.protobuf.core.RepresentationId.prototype.setSystemId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.core.RepresentationId.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.RepresentationId} returns this
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.clearSystemId = function() {
  return this.setSystemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.hasSystemId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string supplied_id = 2;
 * @return {string}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.getSuppliedId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.core.RepresentationId} returns this
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.setSuppliedId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.vertexvis.protobuf.core.RepresentationId.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.RepresentationId} returns this
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.clearSuppliedId = function() {
  return jspb.Message.setOneofField(this, 2, proto.vertexvis.protobuf.core.RepresentationId.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.hasSuppliedId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RepresentationPredefinedId predefined_id = 3;
 * @return {!proto.vertexvis.protobuf.core.RepresentationPredefinedId}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.getPredefinedId = function() {
  return /** @type {!proto.vertexvis.protobuf.core.RepresentationPredefinedId} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.vertexvis.protobuf.core.RepresentationPredefinedId} value
 * @return {!proto.vertexvis.protobuf.core.RepresentationId} returns this
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.setPredefinedId = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.vertexvis.protobuf.core.RepresentationId.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.RepresentationId} returns this
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.clearPredefinedId = function() {
  return jspb.Message.setOneofField(this, 3, proto.vertexvis.protobuf.core.RepresentationId.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.RepresentationId.prototype.hasPredefinedId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.RepresentationPredefinedId = {
  REPRESENTATION_PREDEFINED_ID_INVALID: 0,
  REPRESENTATION_PREDEFINED_ID_EMPTY: 1,
  REPRESENTATION_PREDEFINED_ID_ENTIRE_PART: 2
};

goog.object.extend(exports, proto.vertexvis.protobuf.core);
